export const sortByFields = <T extends { [key: string]: any }>(arr: T[], sort: [string, 'asc' | 'desc'][]) : T[] => {
  const arrCopy = [...arr];
  arrCopy.sort((a, b) => {
    for (let i = 0; i < sort.length; i += 1) {
      const [field, order] = sort[i];
      if (typeof a[field] === 'undefined') {
        return 1;
      }
      if (typeof b[field] === 'undefined') {
        return -1;
      }
      const res = (a[field] - b[field]) * (order === 'asc' ? 1 : -1);
      if (res !== 0) return res;
    }
    return 0;
  });
  return arrCopy;
};
